import { AppStore } from 'src/client/store'
import { USER_LOGIN } from 'actions/apiActionConstants'
import { API_CALL_SUCCESS, ACCOUNT_INIT_COMPLETE } from 'actions/actionConstants'
import { selectLoggedIn } from 'selectors/accountSelectors'
import isBot from 'lib/web/isBot'
import { setDatadogUser } from 'services/datadogRum'

function initialiseUser(store: AppStore) {
  const state = store.getState()
  const loggedIn = selectLoggedIn(state)

  if (loggedIn) {
    store.dispatch({
      type: API_CALL_SUCCESS,
      api: USER_LOGIN,
      data: {
        accessToken: state.auth.accessToken,
        account: state.auth.account,
      },
    })
    setDatadogUser(state.auth.account.memberId)
  } else if (!isBot) {
    // Without a valid SSR-hydrated token we cannot construct an authenticated
    // session on the client. Mark init complete and let the user re-login
    // rather than seeding Redux with an account that has no bearer token,
    // which produces a half-loggedin state where the UI looks authenticated
    // but every API call is rejected.
    store.dispatch({
      type: ACCOUNT_INIT_COMPLETE,
    })
  }
}

export default initialiseUser
